module.exports = __webpack_public_path__ + "static/media/62976__radian__chime-0001.3b6efa0b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/62976__radian__chime-0001.mp3
// module id = 1376
// module chunks = 1